import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const GET_MEDIA = (src?: string) => {
  return `${apiUrl}file-management/download/${src}`;
};
export const UPLOAD_MEDIA = async (data: any) => {
  return await fetchUrl({
    url: `${apiUrl}file-management/upload`,
    method: 'POST',
    body: data,
  });
};
